module.exports = __webpack_public_path__ + "img/kalis_SNB.b0e0afd6.svg";